/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import HeaderEN from "./header.en"
//import "./layout.css"
import { makeStyles } from "@material-ui/core/styles"
import { Container, Paper } from "@material-ui/core"

import Footer from "./footer"
import FooterEN from "./footer.en"

const IndexPageStyle = theme => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      marginLeft: "2rem",
      marginRight: "2rem",
    },
    marginTop: "10rem",
    zIndex: "3",
    position: "relative",
  },
  paper: {
    backgroundColor: "white",
    "@media print": {
      boxShadow: "none",
      border: 0,
    },
  },
  main: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
})

const useStyles = makeStyles(IndexPageStyle)

const Layout = ({ maxWidth = "lg", children, lang = "de" }) => {
  const classes = useStyles()
  return (
    <>
      {lang === "de" ? <Header /> : <HeaderEN />}
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Container
            maxWidth={maxWidth}
            className={classes.main}
            component="main"
          >
            {children}
          </Container>
        </Paper>
        {lang === "de" ? <Footer /> : <FooterEN />}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

// export const pageQuery = graphql`
//   query PageQuery($id: String) {
//     mdx(id: { eq: $id }) {
//       id
//       body
//       excerpt
//       frontmatter {
//         title
//         date
//         tags
//         slug
//         excerpt
//         images {
//           publicURL
//           childImageSharp {
//               fluid(maxWidth: 800, quality: 85) {
//                 ...GatsbyImageSharpFluid_withWebp
//               }
//           }
//         }
//       }
//     }
//   }
// `
